import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AuthDialog from "./components/AuthDialog";
import AuthCallback from "./components/AuthCallback";
import Landing from "./pages/Landing";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import About from "./pages/About";

function Shell() {
  const location = useLocation();
  const { authConfig } = useAuth();
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");

  const openAuth = (mode = "login") => {
    setAuthMode(mode);
    setAuthOpen(true);
  };

  useEffect(() => {
    if (location.hash?.includes("session_id=") && authConfig.mode === "local") {
      window.history.replaceState({}, document.title, location.pathname || "/");
    }
  }, [authConfig.mode, location.hash, location.pathname]);

  // Detect OAuth callback (hash fragment) synchronously during render.
  if (location.hash?.includes("session_id=") && authConfig.external_login_enabled) {
    return <AuthCallback />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar onOpenAuth={openAuth} />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Landing onOpenAuth={openAuth} />} />
          <Route path="/proiecte/:categorySlug/:slug" element={<ProjectDetail onOpenAuth={openAuth} />} />
          <Route path="/proiecte/:segment" element={<Projects onOpenAuth={openAuth} />} />
          <Route path="/proiecte" element={<Projects onOpenAuth={openAuth} />} />
          <Route path="/dashboard" element={<Dashboard onOpenAuth={openAuth} />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/despre" element={<About />} />
          <Route path="*" element={<Landing onOpenAuth={openAuth} />} />
        </Routes>
      </div>
      <Footer />
      <AuthDialog
        open={authOpen}
        onOpenChange={setAuthOpen}
        mode={authMode}
        onModeChange={setAuthMode}
      />
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}
